import { render, staticRenderFns } from "./ezuikitPlayer.vue?vue&type=template&id=c4e72c08"
import script from "./ezuikitPlayer.vue?vue&type=script&lang=js"
export * from "./ezuikitPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports